import { css, cx } from "@emotion/css";
import FormControlLabel from "@mui/material/FormControlLabel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";
import { ExamTypes } from "src/types/enums";

import Filter from "./DefaultFilters";

export default function TimerFilter({ details, setDetails, examTime }) {
	const { t } = useTranslation();
	const [expanded, setExpanded] = useState(true);
	const checked = details.typeDetails.type === ExamTypes.SIMULATION;

	const defaultTime = dayjs()
		.hour(0)
		.minute(0)
		.second(details?.typeDetails.timePerQuestion)
		.millisecond(0);

	const toggleChecked = () => {
		setDetails({
			...details,
			typeDetails: {
				...details.typeDetails,
				type: checked ? ExamTypes.LEARNING : ExamTypes.SIMULATION,
			},
		});
	};

	const setTime = (minutes, seconds) => {
		setDetails({
			...details,
			typeDetails: {
				...details.typeDetails,
				timePerQuestion: minutes * 60 + seconds,
			},
		});
	};

	const renderHeader = () => {
		return (
			<div>
				<FormControlLabel
					className={cx(
						"mr-4",
						css`
              margin-left: -2px;
            `,
					)}
					label={<span>{t("filters.exams.timer.title")}</span>}
					control={
						<Checkbox
							className="p-0"
							checked={checked}
							onChange={toggleChecked}
							data-test-id="timer-filter-checkbox"
						/>
					}
				/>
				{checked && examTime && (
					<span className="text-grey size-14-light">
						({t("filters.exams.timer.examTime")} {examTime.formatTime})
					</span>
				)}
			</div>
		);
	};

	const renderFilters = () => {
		return (
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<div className="flex flex-col gap-8">
					<div className="flex gap-8 items-center disabled-box">
						<span
							className={cx("text-black size-16-light", {
								"text-grey": !checked,
							})}
						>
							{t("filters.exams.timer.timePerQuestion")}
						</span>
						<TimePicker
							views={["minutes", "seconds"]}
							format="mm:ss"
							disableOpenPicker
							slotProps={{
								textField: {
									"data-test-id": "timer-time-input",
								},
							}}
							className={cx(
								"text-field-date",
								css`
                  max-width: 80px;
                `,
							)}
							defaultValue={defaultTime}
							onAccept={(value) => {
								if (!value) {
									setTime(0, 0);
								} else {
									setTime(value.minute(), value.second());
								}
							}}
							disabled={!checked}
						/>
					</div>
					<span className="text-grey size-14-light">
						{t("filters.exams.timer.timeHint")}
					</span>
				</div>
			</LocalizationProvider>
		);
	};

	return (
		<Filter
			onChange={(e) => {
				if (e.target.type !== "checkbox") {
					setExpanded(!expanded);
				}
			}}
			expanded={expanded}
			title={renderHeader()}
			renderFilterDetails={renderFilters}
		/>
	);
}
